import {reportException} from "../Utilities/sentry";

class CategoryService {
    async fetchCategoryTree() {
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };
        try {
            let response = await fetch(
                process.env.REACT_APP_API_URL + "/api/Categories/tree",
                {
                    method: "GET",
                    redirect: "follow",
                }
            );
            let result = await response.json();

            return result;
        } catch (e) {
            reportException(e);
        }
    }

    async fetchCategoryList() {
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };
        try {
            let response = await fetch(
                process.env.REACT_APP_API_URL + "/api/Categories/list",
                requestOptions
            );
            return await response.json();
        } catch (e) {
            reportException(e);
        }
    }

    async fetchCategorySearchList() {
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };
        try {
            let response = await fetch(
                process.env.REACT_APP_API_URL + "/api/Categories/search-list",
                requestOptions
            );
            return await response.json();
        } catch (e) {
            reportException(e);
        }
    }
}

export default new CategoryService();
